import axios from 'axios'
import { REACT_APP_API } from '../../config'

export async function getUserSellerResponsibles(query) {
    try {
        const data = await axios.get(`${REACT_APP_API}/groups/sellerAndResponsibleUsers${query}`)
        return data?.data
    } catch (error) {
        throw new Error(error)
    }
}